export default [
    {
        path: 'sepaccount-rule',
        name: 'sepaccountRule',
        meta: {
            isDynamic: true,
            id: '分账规则',
            inTab: true
        },
        component: () => import('@/views/separateAccount/accountRule')
    },
    {
        path: 'sepaccount-flow',
        name: 'sepaccountFlow',
        meta: {
            isDynamic: true,
            id: '分账流水',
            inTab: true
        },
        component: () => import('@/views/separateAccount/accountFlow')
    },
    {
        path: 'sepaccount-settle',
        name: 'sepaccountSettle',
        meta: {
            isDynamic: true,
            id: '分账结算',
            inTab: true
        },
        component: () => import('@/views/separateAccount/accountSettle')
    },
    {
        path: 'sepaccount-rule-setting',
        name: 'sepaccountRuleSetting',
        component: () => import('@/views/separateAccount/accountRule/setting')
    },
    {
        path: 'sepaccount-auto-setting',
        name: 'sepaccountAutoSetting',
        component: () => import('@/views/separateAccount/accountRule/auto-setting')
    },
    {
        path: 'sepaccount-withdraw',
        name: 'sepaccountWithdraw',
        meta: {
            isDynamic: true,
            id: '团队提现',
            inTab: true
        },
        component: () => import('@/views/separateAccount/accountWithdraw')
    },
    {
        path: 'sepaccount-withdraw-history',
        name: 'sepaccountWithdrawHistory',
        meta: {
            isDynamic: false,
            id: '提现记录',
            inTab: true,
            title: '提现记录'
        },
        component: () => import('@/views/separateAccount/accountWithdraw/withdraw')
    },
    {
        path: 'sepaccount-supuser-withdraw',
        name: 'sepaccountSupuserWithdraw',
        meta: {
            isDynamic: true,
            id: '业务员提现记录',
            inTab: true
        },
        component: () => import('@/views/separateAccount/accountWithdraw/user-withdraw')
    },
]